<template>
  <b-card class="reindex-settings">
    <h2 class="reindex-settings__title">
      {{ $t('settings.sections.reindexing.title') }}
    </h2>
    <p class="text-muted">
      {{ $t('settings.sections.reindexing.description') }}
    </p>

    <b-table-simple
      responsive
      small
      hover>
      <b-thead>
        <b-tr>
          <b-th>{{ $t('settings.sections.reindexing.module') }}</b-th>
          <b-th>{{ $t('settings.sections.reindexing.status') }}</b-th>
          <b-th class="text-right">
            <b-button
              variant="outline-primary"
              size="sm"
              :disabled="isRunning"
              data-testid="reindex-all-button"
              @click="reindexAll">
              {{ $t('settings.sections.reindexing.reindexAll') }}
            </b-button>
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="module in modules"
          :key="module.key">
          <b-td>{{ $t(`settings.sections.reindexing.modules.${module.key}`) }}</b-td>
          <b-td>
            <b-spinner
              v-if="states[module.key].status === 'running'"
              small />
            <b-badge
              v-else-if="states[module.key].status === 'done'"
              variant="success">
              {{ $t('settings.sections.reindexing.done') }}
            </b-badge>
            <b-badge
              v-else-if="states[module.key].status === 'error'"
              variant="danger"
              :title="states[module.key].message">
              {{ $t('settings.sections.reindexing.error') }}
            </b-badge>
          </b-td>
          <b-td class="text-right">
            <b-button
              size="sm"
              variant="primary"
              :disabled="isRunning"
              :data-testid="`reindex-${module.key}-button`"
              @click="confirmAndReindex(module)">
              {{ $t('settings.sections.reindexing.reindex') }}
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-card>
</template>

<script>
import { reindexModule, reindexModules } from '../../../services/reindexService';

export default {
  name: 'ReindexSettings',
  data() {
    const modules = reindexModules();

    return {
      modules,
      states: modules.reduce((states, module) => ({ ...states, [module.key]: { status: null, message: null } }), {})
    };
  },
  computed: {
    isRunning() {
      return Object.values(this.states).some(state => state.status === 'running');
    }
  },
  methods: {
    confirmAndReindex(module) {
      this.$bvModal.msgBoxConfirm(this.$t('settings.sections.reindexing.confirmation', {
        module: this.$t(`settings.sections.reindexing.modules.${module.key}`)
      }), {
        okTitle: this.$t('settings.sections.reindexing.reindex'),
        cancelTitle: this.$t('settings.cancel'),
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.reindex(module);
        }
      });
    },
    reindexAll() {
      this.$bvModal.msgBoxConfirm(this.$t('settings.sections.reindexing.confirmationAll'), {
        okTitle: this.$t('settings.sections.reindexing.reindexAll'),
        cancelTitle: this.$t('settings.cancel'),
        centered: true
      }).then(async confirmed => {
        if (confirmed) {
          for (const module of this.modules) {
            await this.reindex(module);
          }
        }
      });
    },
    reindex(module) {
      this.states[module.key] = { status: 'running', message: null };

      return reindexModule(module)
        .then(() => {
          this.states[module.key] = { status: 'done', message: null };
        })
        .catch(error => {
          this.states[module.key] = { status: 'error', message: error.message };
        });
    }
  }
};
</script>

<style scoped>
.reindex-settings__title {
  font-size: 1.5rem;
}
</style>
